import {
  HexType,
  SpecialVersionType,
  guardNever,
  hexIdToHumanHexId,
} from "@hex/common";

import { ORG_ID } from "../../../../orgs";
import { Routes } from "../../../../route/routes";

import { WithUsagesData } from "./useUsagesCells";

export function getUsageCellHref(params: {
  cell: WithUsagesData["cells"][number];
}): string | undefined {
  const { cell } = params;

  const hexType = cell.hexVersion.hex.hexType;
  const hexLocator = hexIdToHumanHexId(
    cell.hexVersion.hex.id,
    cell.hexVersion.hex.title,
  );
  const version =
    cell.hexVersion.version === SpecialVersionType.DRAFT
      ? SpecialVersionType.DRAFT
      : SpecialVersionType.LAST_PUBLISHED;
  const staticCellId = cell.staticId;

  let href: string | undefined;
  if (hexType === HexType.PROJECT) {
    href = Routes.LOGIC.href(ORG_ID, true, {
      hexLocator,
      version,
      queryParams: {
        selectedStaticCellId: staticCellId,
      },
    });
  } else if (hexType === HexType.ASK) {
    href = undefined;
  } else if (hexType === HexType.EXPLORE) {
    href = Routes.EXPLORE.href(ORG_ID, true, {
      hexLocator,
    });
  } else if (hexType === HexType.COMPONENT) {
    href = Routes.COMPONENT.href(ORG_ID, true, {
      hexLocator,
      version,
      queryParams: {
        selectedStaticCellId: staticCellId,
      },
    });
  } else {
    guardNever(hexType, hexType);
  }

  return href;
}
